import React from "react";

/** Northeast arrow from Figma text outline of “Meet Joni ↗” (node 2042:2812). */
const ArrowNe = () => (
  <svg
    className="mz-arrow-ne"
    width="8.15"
    height="8.16"
    viewBox="69.82 1.32 8.15 8.16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M69.8199 8.715L76.8099 1.74L76.7349 2.415L69.9249 2.385L70.9749 1.32L77.9499 1.365L77.9649 8.34L76.9149 9.405L76.8999 2.58L77.5749 2.505L70.5849 9.48L69.8199 8.715Z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowNe;
